import loadable from '@loadable/component';
export default loadable;
//# sourceMappingURL=index.js.map